import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
//const authentication = require('react-azure-adb2c').default;
//import { Dispatch } from 'redux';


import { call, put, takeEvery, select } from 'redux-saga/effects';
import * as RentContractMoniesApi from '../Api/RentContractMoniesApi';
import * as RentContractAccountingApi from '../Api/RentContractAccountingApi';
import * as WaterApi from '../Api/WaterApi';
// import * as UsersApi from './Api/UsersApi';
// import * as RentAgentsApi from './Api/RentAgentsApi';

///types


//export interface HogeState {
//    responselist: string[];
//    responseedit: number;
//}
export interface RentContractMoniesState {
    // rent_contract_monies:any;
    waters: any;
}
const initialState: RentContractMoniesState = {

    // rent_contract_monies: [],
    waters: []
    // users: [],
    // rentAgents: [],
    // rentMReasons: [],



}



///action 
const actionCreator = actionCreatorFactory();

// export const get_rent_contract_monies = actionCreator<{rent_contract_id:number}>('GET_RENT_CONTRACT_MONIES');
// export const get_rent_contract_monies_success = actionCreator("GET_RENT_CONTRACT_MONIES_SUCCESS");
// export const get_rent_contract_monies_failure = actionCreator("GET_RENT_CONTRACT_MONIES_FAILURE");

// export const get_rent_contract_accounting = actionCreator("GET_RENT_CONTRACT_ACCOUNTING");


export const get_waters = actionCreator('GET_WATERS');
export const change_waters = actionCreator("CHANGE_WATERS");

// export const update_kyousai_comp = actionCreator('UPDATE_KYOUSAI_COMP');

// export const get_banks_failure = actionCreator("GET_BANKS_FAILURE");

// export const getUsers = actionCreator('USERS_REQUEST');
// export const getUsersSuccess = actionCreator("USERS_SUCCESS");
// export const getUsersFailure = actionCreator("USERS_FAILURE");

// export const getRentAgents = actionCreator('RENT_AGENTS_REQUEST');
// export const getRentAgentsSuccess = actionCreator("RENT_AGENTS_SUCCESS");
// export const getRentAgentsFailure = actionCreator("RENT_AGENTS_FAILURE");


// export const getRentMReasons = actionCreator('RENT_M_REASONS_REQUEST');
// export const getRentMReasonsSuccess = actionCreator("RENT_M_REASONS_SUCCESS");
// export const getRentMReasonsFailure = actionCreator("RENT_M_REASONS_FAILURE");


export const waterReducer = reducerWithInitialState(initialState)
    .case(get_waters, (state, payload) => ({ ...state, waters: payload }))
// .case(get_rent_contract_monies_success, (state, payload) => ({ ...state, rent_contract_monies: payload }));



//.case(getRentMMedeasFailure, (state, payload) => ({ ...state, rentMMedeas: payload }))
// .case(getUsersSuccess, (state, payload) => ({ ...state, users: payload }))
// .case(getUsersFailure, (state, payload) => ({ ...state, users: payload }))
// .case(getRentAgentsSuccess, (state, payload) => ({ ...state, rentAgents: payload }))
// .case(getRentAgentsFailure, (state, payload) => ({ ...state, rentAgents: payload }))
// .case(getRentMReasonsSuccess, (state, payload) => ({ ...state, rentMReasons: payload }))
// .case(getRentMReasonsFailure, (state, payload) => ({ ...state, rentMReasons: payload }));






// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const waterSaga = [
    //     takeEvery('GET_RENT_CONTRACT_MONIES', handleRequestMoney),
    // takeEvery('GET_RENT_CONTRACT_ACCOUNTING', handle_get_rent_contract_accounting),
    takeEvery('GET_WATERS', handle_get_waters),
    // takeEvery('UPDATE_KYOUSAI_COMP', handle_update_kyousai_comp),
    // takeEvery('RENT_AGENTS_REQUEST', handleRentAgentsRequest),
    // takeEvery('RENT_M_REASONS_REQUEST', handleRentMReasonsRequest),
];
// export default masterSaga;



// function* handleRequestMoney(action:any) {

//  const { payload, error }= yield call(RentContractMoniesApi.get_money_list, action.payload);

//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {
//         // 成功時アクション呼び出し
//     console.log(payload)
//     yield put(get_rent_contract_monies_success(payload));

//     } else {
//     //    // 失敗時アクション呼び出し
//     //    yield put(loginFailure(payload));
//     }
// }



// function* handle_get_rent_contract_accounting(action:any) {

//     const { payload, error }= yield call(RentContractAccountingApi.list, action.payload);

//        // サーバーからのレスポンスデータによる分岐処理
//        if (payload && !error) {
//            // 成功時アクション呼び出し
//        console.log(payload)
//        const a = document.createElement('a');
// // ダウンロードされるファイル名
// a.download = "会計.csv";
// a.href = URL.createObjectURL(payload);
// // ダウンロード開始
// a.click();
//     //    yield put(get_rent_contract_monies_success(payload));

//        } else {
//        //    // 失敗時アクション呼び出し
//        //    yield put(loginFailure(payload));
//        }
//    }



function* handle_get_waters(action: any) {
    console.log(action.payload)

    const { payload, error } = yield call(WaterApi.list, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)

        // yield put(change_kyousais(payload));
        //    yield put(get_rent_contract_monies_success(payload));

    } else {

        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}





// function* handle_update_kyousai_comp(action: any) {
//     const state = yield select();
//     let kyousais = state.kyousaiReducer.kyousais
//     let waters = state.waterReducer.kyousais
//     // console.log(kyousais)
//     let kyousaisset = kyousais.filter((a: any) => a.select === 1)
//     console.log(kyousaisset)

//     const { payload, error } = yield call(WaterApi.update, kyousaisset);

//     if (payload && !error) {
//         // console.log(payload)
//         // alert()
//         yield put(change_kyousais(payload));
//         //  yield put(change_kyousais(payload));
//         //    yield put(get_rent_contract_monies_success(payload));

//     } else {

//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }
// }

// function* handleRentAgentsRequest(action: any) {

//     let { payload } = action;
//     payload = yield call(RentAgentsApi.RentAgentsList, payload);

//     // サーバーからのレスポンスデータによる分岐処理
//     //if (ログイン成功か失敗かの条件) {
//     // 成功時アクション呼び出し
//     console.log(payload)

//     yield put(getRentAgentsSuccess(payload));
//     //} else {
//     //    // 失敗時アクション呼び出し
//     //    yield put(loginFailure(payload));
//     //}
// }

// function* handleRentMReasonsRequest(action: any) {

//     let { payload } = action;
//     payload = yield call(RentMReasonsApi.RentMReasonsList, payload);

//     // サーバーからのレスポンスデータによる分岐処理
//     //if (ログイン成功か失敗かの条件) {
//     // 成功時アクション呼び出し
//     console.log(payload)

//     yield put(getRentMReasonsSuccess(payload));
//     //} else {
//     //    // 失敗時アクション呼び出し
//     //    yield put(loginFailure(payload));
//     //}
// }